import i18next from 'i18next';
import { initI18n } from '@invite/app-core';
import en from './resources/en/owner.json';
import nb from './resources/nb/owner.json';

export const NAMESPACES = ['owner'] as const;
export type Namespace = (typeof NAMESPACES)[number];

initI18n<Namespace>({
  resources: { en: { owner: en }, nb: { owner: nb } },
  defaultNS: 'owner'
});

export default i18next;
